import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { verifyPayment } from '../../../store/api.js';
import { useSelector, useDispatch } from 'react-redux';
import { resetPaymentStatus } from '../../../store/reguestSlice.js';

export function ReturnPage() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { statusPay, subsPay, errorPay } = useSelector(state => state.payment);

  useEffect(() => {
    // 1. Получаем параметры из URL
    const params = new URLSearchParams(window.location.search);
    const paymentId = params.get('paymentId') || params.get('payment_id');
    
    console.log('Payment ID from URL:', paymentId, params); // Для отладки
    
    // 2. Если нет payment_id, проверяем другие возможные параметры
    if (!paymentId) {
      console.log('No payment_id in URL, checking alternative params...');
      const altParams = {
        paymentId: params.get('paymentId'),
        orderId: params.get('orderId')
      };
      console.log('Alternative params:', altParams);
      
      //history.replace('/subscription?error=missing_payment_id');
      return;
    }

    // 3. Запрашиваем проверку платежа
    dispatch(verifyPayment(paymentId));

    return () => {
      dispatch(resetPaymentStatus());
    };
  }, [dispatch, history]);

  useEffect(() => {
    if (statusPay === 'succeeded') {
      const timer = setTimeout(() => {
        // 4. Добавляем ID подписки при редиректе
        history.push({
          pathname: '/profile',
          search: `?payment=success&subId=${subsPay?.id || ''}`,
          state: { subscription: subsPay } // Доп данные через state
        });
      }, 3000);
      
      return () => clearTimeout(timer);
    }
    
    if (statusPay === 'rejected') {
      history.replace({
        pathname: '/subscription',
        search: `?error=${encodeURIComponent(errorPay || 'payment_failed')}`
      });
    }
  }, [statusPay, subsPay, errorPay, history]);

  // 5. Дополнительная отладка
  console.log('Current status:', {
    statusPay,
    subsPay,
    errorPay,
    location: window.location.search
  });

  return (
    <div className="return-page">
      {statusPay === 'loading' && (
        <>
          <h2>Проверка статуса платежа...</h2>
          <div className="loader"></div>
          <p>Параметры URL: {window.location.search}</p> {/* Отображение параметров */}
        </>
      )}
      {statusPay === 'succeeded' && (
        <div className="success-message">
          <h2>Оплата прошла успешно!</h2>
          <p>Подписка активирована. Перенаправляем в личный кабинет...</p>
        </div>
      )}
      {statusPay === 'rejected' && (
        <div className="error-message">
          <h2>Ошибка оплаты</h2>
          <p>{errorPay}</p>
        </div>
      )}
      <p>Текущие параметры URL: {window.location.search}</p>
    </div>
  );
}